"use client";

import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import "./animated-list.css";

export function AnimatedList({ className = "", children, delay = 1000 }) {
  const [items, setItems] = useState([]);
  const childrenArray = Array.isArray(children) ? children : [children];
  const [maxItems, setMaxItems] = useState(null);

  useEffect(() => {
    if (!maxItems) return;
    const intervals = [];
    let loopTimeout;

    const runAnimation = () => {
      setItems([]); // Clear items before starting

      childrenArray.forEach((child, index) => {
        const interval = setTimeout(() => {
          setItems((prev) =>
            [{ id: `${Date.now()}-${index}`, content: child }, ...prev].slice(
              0,
              maxItems
            )
          );
        }, index * delay);
        intervals.push(interval);
      });

      const totalDuration = childrenArray.length * delay + 2000;
      loopTimeout = setTimeout(() => {
        runAnimation();
      }, totalDuration);
    };

    runAnimation();

    return () => {
      intervals.forEach(clearTimeout);
      clearTimeout(loopTimeout);
    };
  }, [maxItems, childrenArray, delay]);

  useEffect(() => {
    function update() {
      const width = window.innerWidth;

      if (width < 640) setMaxItems(5);
      else setMaxItems(5);
    }

    update();
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, []);

  return (
    <div
      className={`r2-animated-list ${className}`}
    >
      <AnimatePresence mode="popLayout">
        {items.map((item, index) => (
          <motion.div
            key={item.id}
            layout
            initial={{ opacity: 0, scale: 0.8, y: -40 }}
            animate={{
              opacity: 1,
              scale: 1,
              y: 0,
              transition: {
                duration: 1,
                ease: [0.16, 1, 0.3, 1],
              },
            }}
            exit={{
              opacity: 0,
              scale: 0.95,
              transition: { duration: 0.3 },
            }}
            transition={{
              layout: {
                duration: 0.8,
                ease: [0.16, 1, 0.3, 1],
              },
            }}
            className={`r2-animated-list__item ${
              index === 0 ? "r2-animated-list__item--active" : ""
            }`}
          >
            {item.content}
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
}
